// removed by extract-text-webpack-plugin
module.exports = {"content":"VmwxVDMCBmVJE7nsYxoPC","chatWindow":"_2NL0FhSUmPJEx3n2RRST5x"};


//////////////////
// WEBPACK FOOTER
// ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!./~/vue-style-loader!./~/css-loader?{"minimize":true,"sourceMap":true,"localIdentName":"[hash:base64]","modules":true,"importLoaders":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-f25256f4","scoped":false,"hasInlineConfig":false}!./~/less-loader/dist/cjs.js?{"sourceMap":true}!./src/components/live-coach-call/live-coach-call.less
// module id = WFSx
// module chunks = 1